import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import Dashboard from "../../dashboard/containers/Dashboard";
import { baseActions } from "../models/BaseSlice";
import Projects from "../../project/containers/Projects";
import CompareDashboard from "../../dashboard/containers/CompareDashboard";
import ProjectDelays from "../../project/containers/ProjectDelays";

import DialogBox from "./DialogBox";
import NewsFeed from "../../dashboard/containers/NewsFeed";
import ProjectContents from "../../project/containers/ProjectContents";
import MainComponent from "../../project/components/dark_version/ProjectDetails/MainComponent";
import ProjectEditorPC from "../../project/containers/ProjectEditorPC";
import ConceptPaperContainer from "../../potential_projects/containers/ConceptPaperContainer";
import PledgeStatusEditing from "../../editing/PledgeStatusEditing";
import CommonUtils from "../utils/CommonUtils";
import PSDPProjects from "../../project/containers/PSDPProjects";
import ADPProjects from "../../project/containers/ADPProjects";
import PPPProjects from "../../project/containers/PPPProjects";

export const dialogBoxRef = React.createRef<DialogBox>();

interface IProps {
  children: JSX.Element;
}

const Protected = (props: IProps) => {
  // const isAuthenticated = UserUtils.isLoggedIn()
  // const [auth, setAuth] = React.useState<boolean>(false);
  const auth = useSelector((state: any) => state.auth.isAuthenticated);
  const navigate = useNavigate();
  const { children } = props;

  if (!auth) {
    CommonUtils.checkUserAuthentication().then((response) => {
      if (!response) {
        navigate("/");
        alert("Failed to login. " + "Please check your credentials");
      }
    });
  }

  return (
    <React.Fragment>
      {auth ? (
        children
      ) : (
        <>
          <h3>Please login to access this page</h3>
        </>
      )}
    </React.Fragment>
  );
};
const ContentRouter = () => {
  // const dispatch =  useDispatch()

  const topAppbarHeight = useSelector(
    (state: any) => state.base.topAppbarHeight,
  );
  const showBar = useSelector((state: any) => state.base.showBars);
  const isAuthenticated = useSelector(
    (state: any) => state.auth.isAuthenticated,
  );
  const [height, setHeight] = useState<string>("200");

  const dispatch = useDispatch();
  // dispatch(baseActions.setShowBar(true));
  useEffect(() => {
    if (showBar) {
      const dashboardHeight =
        document.getElementById("dashboard-div")?.clientHeight || 0;
      const h =
        dashboardHeight > topAppbarHeight
          ? dashboardHeight - topAppbarHeight
          : document.body.clientHeight;
      setHeight(h.toString());
      dispatch(baseActions.setContentDivHeight(h));
    } else {
      setHeight("100vh");
      dispatch(baseActions.setContentDivHeight(-1));
    }
  }, [topAppbarHeight]);

  return (
    <div id={"content-div"} style={{ height: height, color: "white" }}>
      <Routes>
        <Route path={"/pc_editor"} element={<ProjectEditorPC />} />
        <Route path={"/psdp_projects"} element={<PSDPProjects />} />
        <Route path={"/ppp_projects"} element={<PPPProjects />} />
        <Route path={"/adp_projects"} element={<ADPProjects />} />
        <Route path={"/projects"} element={<Projects />} />
        <Route
          path={"/projects_editing"}
          element={
            <Protected>
              <ProjectEditorPC />
            </Protected>
          }
        />
        <Route
          path={"/pledge_editing"}
          element={
            <Protected>
              <PledgeStatusEditing />
            </Protected>
          }
        />
        <Route path="/projectInfo" element={<ProjectContents />} />
        {/*<Route path="/banner" element={<Banner />} />*/}
        <Route
          path={"/project_physical_progress"}
          element={<ProjectContents />}
        />
        <Route
          path={"/upload_concept_paper"}
          element={<ConceptPaperContainer />}
        />
        <Route path={"/photo_gallery"} element={<ProjectContents />} />
        <Route path="/compare" element={<CompareDashboard />} />
        <Route path="/delays" element={<ProjectDelays />} />
        <Route
          path="/manage_project"
          element={isAuthenticated ? <ProjectEditorPC /> : <Dashboard />}
        />
        <Route path="/news" element={<NewsFeed />} />
        <Route path="" element={<Dashboard />} />
        <Route path="/projectdetails" element={<MainComponent />} />
      </Routes>
      <DialogBox ref={dialogBoxRef} />
    </div>
  );
};
export default ContentRouter;
